/**
 * A ponte com o app para computador (`window.alternativaDesktop`, exposta
 * pelo preload do Electron). No navegador não existe: tudo daqui some.
 */
export type EstadoAtualizacao =
  | { fase: 'nada' }
  | { fase: 'verificando' }
  | {
      fase: 'baixando';
      versao: string;
      baixado: number;
      total: number;
      obrigatoria: boolean;
    }
  | { fase: 'pronta'; versao: string; notas: string[] }
  | { fase: 'erro'; mensagem: string };

export type AjustesDoApp = {
  fecharParaBandeja: boolean;
  abrirComSistema: boolean;
  plataforma: string;
  empacotado: boolean;
};

type Cancelar = () => void;

export type PonteDesktop = {
  plataforma: 'darwin' | 'win32' | 'linux' | string;
  versao: string;
  janela: {
    minimizar(): void;
    maximizar(): void;
    fechar(): void;
    estado(): Promise<{
      maximizada: boolean;
      focada: boolean;
      telaCheia: boolean;
    } | null>;
    aoMudar(
      callback: (estado: {
        maximizada: boolean;
        focada: boolean;
        telaCheia: boolean;
      }) => void,
    ): Cancelar;
  };
  notificar(aviso: {
    titulo: string;
    corpo: string;
    rota?: string;
    tag?: string;
  }): void;
  badge(quantidade: number, imagem?: string): void;
  status(status: string): void;
  aoStatus(callback: (status: string) => void): Cancelar;
  aoNavegar(callback: (rota: string) => void): Cancelar;
  abrirNoNavegador(url: string): void;
  atualizacao: {
    estado(): Promise<EstadoAtualizacao | null>;
    verificar(): Promise<EstadoAtualizacao | null>;
    reiniciar(): void;
    aoMudar(callback: (estado: EstadoAtualizacao) => void): Cancelar;
  };
  ajustes: {
    obter(): Promise<AjustesDoApp | null>;
    definir(
      parte: Partial<
        Pick<AjustesDoApp, 'fecharParaBandeja' | 'abrirComSistema'>
      >,
    ): Promise<AjustesDoApp | null>;
  };
};

export function ponteDesktop(): PonteDesktop | null {
  if (typeof window === 'undefined') return null;
  return (
    (window as unknown as { alternativaDesktop?: PonteDesktop })
      .alternativaDesktop ?? null
  );
}

/** Desenha o contador do ícone da barra de tarefas do Windows (32×32). */
export function imagemDoBadge(quantidade: number): string | undefined {
  if (typeof document === 'undefined') return undefined;
  const tela = document.createElement('canvas');
  tela.width = 32;
  tela.height = 32;
  const ctx = tela.getContext('2d');
  if (!ctx) return undefined;
  ctx.fillStyle = '#E5484D';
  ctx.beginPath();
  ctx.arc(16, 16, 15, 0, Math.PI * 2);
  ctx.fill();
  ctx.fillStyle = '#FFFFFF';
  ctx.font = `bold ${quantidade > 9 ? 15 : 19}px system-ui, sans-serif`;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText(quantidade > 9 ? '9+' : String(quantidade), 16, 17);
  return tela.toDataURL('image/png');
}
